<template>
  <form @submit.prevent="handleSubmit(item)" novalidate>
    <div :class="{ 'form-group': true, 'has-error': (errors && errors.name) }">
      <label for="_name" class="control-label">Nazwa</label>
      <input v-model="item.name" type="text" id="_name" class="form-control" />
      <span v-if="errors && errors.name" class="help-block" id="_name_helpBlock">{{ errors.name }}</span>
    </div>

    <router-link :to="{ name: 'InvoicePaymentTypeList' }" class="btn btn-primary"><span>Powrót</span><svg-icon name="back"/></router-link>
    <my-button text="Zapisz" icon="tick" type="submit" />
  </form>
</template>

<script>
  export default {
    props: {
      handleSubmit: {
        type: Function,
        required: true,
      },
      values: {
        type: Object,
        required: true
      },
      errors: {
        type: Object
      },
      initialValues: {
        type: Object
      }
    },
    computed: {
      item: function () {
        return this.initialValues ? this.initialValues : this.values;
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Form.vue?566ef384